// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"8":"bb6756bd","453":"b3bc45a7"}[chunkId] + ".chunk.js");